import { toast } from "sonner";

import { getApiErrorMessage } from "@/lib/api";
import { errorDeNombreDePerfil } from "@/lib/perfiles";

/**
 * Tratamiento del fallo de guardado, compartido por el alta y la edición de
 * perfil: si el 422 trae un error del campo `nombre` va PEGADO al campo (ahí
 * se corrige); cualquier otro fallo va a un toast, que es el respaldo para no
 * tragarse el detalle.
 *
 * Estaba escrito dos veces, idéntico salvo el texto del fallback. Duplicado,
 * arreglar el mapeo en una pantalla dejaba la otra rota sin que nada avisara.
 */
export function manejarErrorDeGuardado(
  error: unknown,
  errorDeNombre: (mensaje: string) => void,
  fallback: string,
): void {
  const mensaje = errorDeNombreDePerfil(error);

  if (mensaje) {
    errorDeNombre(mensaje);
    return;
  }

  toast.error(getApiErrorMessage(error, fallback));
}
